import CircularProgress from '@mui/joy/CircularProgress';
import { Button, ButtonProps } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

type LoadingButtonProps = {
  isLoading?: boolean;
  isDisabled?: boolean;
  variant: ButtonProps['variant'];
  children: React.ReactNode;
  onClick: () => void;
};

const LoadingIcon = (): ReactElement => (
  <CircularProgress size="sm" sx={{ '--CircularProgress-size': '12px' }} thickness={2} />
);

export const LoadingButton = ({
  children,
  isDisabled,
  isLoading,
  onClick,
  variant,
}: LoadingButtonProps): ReactElement => (
  <Button
    variant={variant}
    size="base"
    rounded="regular"
    onClick={onClick}
    disabled={isDisabled}
    startIcon={isLoading && <LoadingIcon />}
  >
    {children}
  </Button>
);
